import {z} from '@hono/zod-openapi';

export const enhanceMessageResponseSchema = z
  .object({
    body: z
      .string()
      .min(1)
      .max(10000)
      .openapi({example: 'Dobrý den, posíláme Vám potvrzení objednávky {{ order.number }}.'}),
    subject: z
      .string()
      .min(1)
      .max(500)
      .optional()
      .openapi({example: 'Vaše objednávka {{ order.number }}'}),
  })
  .openapi('EnhanceMessageResponse');

export type EnhanceMessageResponse = z.infer<typeof enhanceMessageResponseSchema>;
